import { render, staticRenderFns } from "./OListAdd.vue?vue&type=template&id=094b22de&"
import script from "./OListAdd.vue?vue&type=script&lang=js&"
export * from "./OListAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports